<template>
  <th
    :style="[styleWidth]"
    :class="[
      col.cssCellClass,
      { empty: !col.caption, 'sticky lock': col.lock },
      String(col.alignHeader || col.align || ''),
    ]"
    :field="col.dataField"
  >
    <div :class="filterable ? 'flex-column' : ''">
      <div :class="['ms-th-content flex-row', filterable ? 'flex' : '']">
        <div
          class="ms-th-title flex flex-row"
          :title="col.tooltip || col.title || col.definition || col.caption"
          :class="[
            {
              'has-lock': col.lockable !== false,
              'has-sort': col.sortable !== false,
              'pdl-10': col.lockable === false,
              'pdr-10': !col.sortable,
            },
            col.cssThTitleClass,
          ]"
        >
          <!-- @click="sort" -->
          <!-- <div
            v-if="col.lockable !== false && !col.group"
            class="icon24 lock"
            :class="{ locked: col.lock }"
            @click="lockClick"
          ></div> -->
          <!-- v-tooltip="col.tooltip " -->
          <span
            :class="['flex', `text-${col.alignHeader || col.align || 'left'}`, col.cssClass]"
            >{{ col.caption }}</span
          >
          <!-- Sort tạm thời chwua dùng đến -->
          <!-- <div
            class="icon24 mi-arrow-dropdown ml5 mr0"
            :class="[
              { sort: sortStatus == $ms.constant.SortStatus.none },
              { 'sort-desc': sortStatus == $ms.constant.SortStatus.desc },
              { 'sort-asc': sortStatus == $ms.constant.SortStatus.asc },
            ]"
            @click="sort"
            v-if="col.sortable !== false"
          ></div> -->
        </div>

        <!-- <div
        class="ms-lock"
        :class="{ locked: col.lock }"
        v-if="col.lockable !== false && false"
        @click="lockClick"
      ></div> -->
        <div
          v-if="resizeCol"
          class="ms-resize"
          @mouseup="resizeOff"
          @mousedown="resizeOn"
        />
      </div>
      <template v-if="filterable">
        <component
          :is="filterComponentName"
          v-if="col.filterable && filterComponentName"
          ref="cpnFilter"
          :col="col"
          @filter-header="filterHeaderHandle"
        />
        <div v-else class="filter-container-empty" />
      </template>
    </div>
  </th>
</template>
<script>
import { defineComponent, onMounted, ref } from 'vue';
import { useColumnResize } from '@/setup/grid/resizeColumn.js';

//FilterComponent
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import msThText from './columnOption/MsThOptionText.vue';
import msThBoolean from './columnOption/MsThOptionBoolean.vue';
import msThNumber from './columnOption/MsThOptionNumber.vue';
import msThDate from './columnOption/MsThOptionDate.vue';
import msThEnum from './columnOption/MsThOptionEnum.vue';

export default defineComponent({
  name: 'MsTh',
  components: {
    msThText,
    msThBoolean,
    msThNumber,
    msThDate,
    msThEnum,
  },
  props: {
    col: {},
    data: {},
    resizeCol: {
      default: true,
      type: Boolean,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    moduleAutocomplete: {
      type: String,
      default: null,
    },
  },
  emits: [
    'resizeOn',
    'resizeOff',
    'changeColumnResize',
    'sort',
    'changeLock',
    'filter',
    'resizeCol',
  ],
  setup(props, { emit }) {
    let filterComponentName = ref(null);
    let cpnFilter = ref(null);

    //Lấy hàm trong fn chung
    const { getFilterType } = setup(props, { emit });

    //Hooks
    /**
     * Build component filter theo data type control
     * HTHIEP 14.03.2022
     */
    onMounted(() => {
      filterComponentName.value = getFilterType(props.col);
      widthx.value = props.col._width;
    });

    /**
     * Trigger sự kiện filter từ con
     * HTHIEP 14.03.2022
     */
    const filterHeaderHandle = (value) => {
      emit('filter', { col: props.col, value });
    };

    /**
     * Xóa giá trị trên cột filter
     * HTHIEP 14.03.2022
     */
    const removeFilter = (trigger = true) => {
      cpnFilter.value.removeFilter(trigger);
    };

    const {
      sortStatus,
      styleWidth,
      sort,
      lockClick,
      updateColWidth,
      resizeOn,
      widthx,
      resizeOff,
    } = useColumnResize({ props, emit });
    return {
      styleWidth,
      sortStatus,
      filterComponentName,
      cpnFilter,
      sort,
      lockClick,
      updateColWidth,
      resizeOn,
      filterHeaderHandle,
      removeFilter,
      resizeOff,
    };
  },
  methods: {},
});
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/function.scss';
li.filter-operator-item {
  align-items: center;
  &.active {
    background-color: #e2f2ff;
  }
}
.ms-th {
  .filter-container-empty {
    height: $ms-filter-grid-height;
    border-top: 1px solid $ms-th-grid-border-color;
    background: #fff;
  }
  .filter-container {
    height: $ms-filter-grid-height;
    border-top: 1px solid $ms-th-grid-border-color;
    .menu-wrapper {
      &.active button {
        background-color: #e2f2ff;
      }
    }

    &.filter-container-boolean {
      .filter-value {
        background: #fff;
      }
    }
    .filter-op {
      position: relative;
      z-index: 2;

      .btn-filter-operator {
        height: $ms-filter-item-grid-height;
        width: $ms-filter-operator-grid-width;
        border: none;
        border-right: 1px dotted $ms-th-grid-border-color;
        background: #fff;
        padding: 0;
        cursor: pointer;
        &:focus,
        &:active,
        &:focus-visible {
          outline: none;
        }
      }
    }
    .filter-value {
      .ms-input-filter-value {
        .ms-input-item,
        .ms-number-item,
        .ms-input--datepicker,
        .combo-box-input input {
          height: $ms-filter-item-grid-height;
          border-radius: 0;
          &:focus {
            outline: none;
          }
        }
        .ms-container--datepicker {
          &:hover {
            .ms-calendar:not(.disabled) {
              &::before {
                display: block;
              }
            }
          }

          .ms-calendar {
            &::before {
              display: none;
            }

            &.disabled:before {
              background-position: -17px -137px;
            }
          }
        }
        .combo-box-input div div {
          background: #fff;
        }
        .icon-combo--dropdown {
          height: $ms-filter-item-grid-height;
          background: #fff;
          border-left: 1px dotted $ms-th-grid-border-color;
          border-radius: 0;
        }
      }
      position: relative;
      z-index: 1;
    }
  }

  .sort::before {
    background-position: -48px -120px;
  }
  .sort-desc::before {
    background-position: 0 -120px;
  }
  .sort-asc::before {
    background-position: -24px -120px;
  }
}
</style>